import React from 'react'
import { css } from '@emotion/core'
import { NoticeLoading } from '@fs/zion-icon'
import { boolAttr } from '@fs/zion-frontend-friends'

// #region Styles
const defaultSpinnerCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;

  &[is-container] {
    height: 100%;
    width: 100%;
  }
`
// #endregion

export default function PageSpinner({ container, ...props }) {
  return (
    <div {...props} is-container={boolAttr(container)} css={defaultSpinnerCss}>
      <NoticeLoading size="lg" />
    </div>
  )
}
